document.addEventListener("DOMContentLoaded", () => {   
    function fetchAttributes() {
        fetch(`${window.location.origin}?section_id=cart-attributes`).then(response => {
            return response.text();
        }).then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const cartAttributes = doc.querySelector('div').innerHTML;
            if(document.querySelector('#hidden-inputs-cart')) document.querySelector('#hidden-inputs-cart').innerHTML = cartAttributes;
            document.dispatchEvent(new Event('update-cart-attributes'));
        });
    }
    fetchAttributes();
    document.addEventListener('cart:item:added', function() {
        fetchAttributes();
    });
    document.addEventListener('cart:item:update', function() {
        fetchAttributes();
    });
});